import * as React from "react";
import { connect } from "react-redux";
import { toggleGameAnimation } from "../../graphics/GetBuildingGraphicIso";
import { IdStyles } from "../../less/IdStyles";
import { utilAnimation } from "../../utils/animation/utilAnimation";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ButtonDelete } from "../generic/common/ButtonDelete";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { FontWithOutline } from "../generic/font-with-outline/FontWithOutline";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { TextLoca } from "../generic/text/TextLoca";
import { Toggle } from "../generic/toggle/Toggle";
import { actionPlayerSettingsToggleAnimation } from "../info/player-settings/actionPlayerSettingsInfo";
var _SettingsToggleAnimation = function (_a) {
    var animationEnabled = _a.animationEnabled, toggleAnimation = _a.toggleAnimation;
    return (React.createElement(Toggle, { on: animationEnabled }, function (on, toggle) {
        var locaId = on
            ? IdLoca.settingsMenu_animationsOn
            : IdLoca.settingsMenu_animationsOff;
        var onClick = function () {
            var next = toggle();
            utilAnimation.setAnimationSettings(next, false);
            toggleGameAnimation(next, function () { return toggleAnimation(next); });
        };
        var ButtonComponent = on ? ButtonPrimary : ButtonDelete;
        return (React.createElement(ButtonComponent, { onClick: onClick },
            React.createElement(Icon, { icon: IdIcon.AnimationsIcn, styleId: IdStyles.IconMedium }),
            React.createElement(FontWithOutline, { style: IdStyles.TextButtonDefault },
                React.createElement(TextLoca, { id: locaId }))));
    }));
};
var mapState = function (state) {
    return {
        animationEnabled: state.playerSettingsInfo.animationEnabled,
    };
};
var mapDispatch = function (dispatch) { return ({
    toggleAnimation: function (animation) {
        return dispatch(actionPlayerSettingsToggleAnimation(animation));
    },
}); };
export var SettingsToggleAnimation = connect(mapState, mapDispatch)(_SettingsToggleAnimation);



//////////////////
// WEBPACK FOOTER
// ./src/features/settings/SettingsToggleAnimation.tsx
// module id = 2755
// module chunks = 3